import React from 'react';

const FooterNew = () => {
  return (
    <footer className="bg-[#0A0A0B] border-t border-white/10 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-lg font-bold">
            COPYRIGHT © Steven Yong
          </p>
          <div className="text-sm text-gray-500 leading-relaxed space-y-4">
            <p>
              <strong className="text-gray-400">Disclaimer:</strong> Earning potential is entirely dependent on the person using our product, ideas and techniques. We do not purport this as a "get rich scheme." Your level of success in attaining the results claimed in our materials depends on the time you devote to the program, ideas and techniques mentioned, your finances, knowledge and various skills. Since these factors differ according to individuals, we cannot guarantee your success or income level. We cannot guarantee that you will make any money at all. Nor are we responsible for any of your actions.
            </p>
            <p>
              This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;